import { Component, OnDestroy, Input, TemplateRef, ContentChild } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';



@Component({
    selector: 'btn-cell-renderer-summary',
    template: `
	<em class="table_edit">
	<img style="padding-right:16px;color-red" src="./assets/images/file-alt-regular.svg" 
	(click)="btnClickedHandler($event,'summary')" style="cursor:pointer;"> 
	</em>
	`,
    standalone: false
})
export class BtnCellRendererSummary implements ICellRendererAngularComp, OnDestroy {



	refresh(params: ICellRendererParams): boolean {
		throw new Error(`Error while refreshing renderer component. INFO-${params}`);
	}

	private params: any;
	pageName;

	agInit(params: any): void {
		this.params = params;
		this.pageName = this.params.colDef.field;

	}

	btnClickedHandler(_event, action) {





		if (action == 'summary') {  // NOSONAR
			this.params.context.componentParent.summaryTemplateRow(this.params.data.kpiId, this.params.data.route,this.params.data.userId);
		}


	}

	ngOnDestroy() {
console.info()


	}
}
